<template>
    <el-card class="absolute top-right fs-3 zi-100">
        <div class="flex-level mt-O pb-3 bb-1">
            <h3 class="flex m-0">{{ $l10n.__('Gestion des lignes') }}</h3>
            <a class="close-btn" @click.prevent="$store.commit(`${listinghash}/hideDisplay`, 'table')">
                &times;
            </a>
        </div>

        <div class="form-group-block mt-3" v-if="showDisplayPagination">
            <label class="form-label label-auto pb-3 semibold">
                {{ $l10n.__("Nombre d'éléments par page") }} :
            </label>
            <div class="form-input">
                <label class="form-label label-block pb-2" v-for="perpage in perPageOptions" :key="perpage">
                    <input type="radio" name="perpage" v-model="nbPerPage" :value="perpage" /> {{ perpage }}
                </label>
            </div>
        </div>

        <div class="form-group-block mt-2" v-if="showDisplayMode">
            <label class="form-label label-auto pb-3 semibold">{{ $l10n.__("Choix du type d'affichage des listes") }}</label>

            <div class="form-input">
                <label class="form-label label-block label-auto pb-2" v-for="display in displayModes" :key="display.class">
                    <input type="radio" name="displayType" v-model="tableDisplay" :value="display.class"/> 
                    <span v-html="display.label" />
                </label>
            </div>
        </div>
    </el-card>
</template>

<script>
    import { Card } from 'element-ui';
    import _ from 'lodash';

    export default {
        props : {
            listinghash:{
                type:String,
                required:true,
            },
            showDisplayMode : {
                type:Boolean,
                default : false,
            },
            showDisplayPagination:{
                type:Boolean,
                default : true,
            }
        },

        data () {
            return {
                perPageOptions : [25, 50, 75],
                displayModes : [
                    {
                        label: this.$l10n.__('Étendu'),
                        class: 'standard',
                    },
                    {
                        label: this.$l10n.__('Condensé'),
                        class: 'condensed',
                    }
                ],
            } 
        },

        computed : {
            nbPerPage:{
                get(){
                    return this.$store.state[this.listinghash].pagination.per_page;
                },
                set(value){
                    this.$store.commit(`${this.listinghash}/updatePerPage`, value);
                    this.$store.dispatch(`${this.listinghash}/fetch`);
                }
            },

            tableDisplay: {
                get(){
                    return this.$store.state[this.listinghash].display.density;
                },
                set(value){
                    this.$store.commit(`${this.listinghash}/updateDisplay`, {'density' : value});
                    this.$store.dispatch(`${this.listinghash}/updateDisplay`);
                }
            }
        }
    }
</script>


<style lang="sass" scoped>
    .displaysettings{
        width:320px;
    }
</style>